import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from '@/contexts/AuthContext';

/**
 * Access the auth context.
 *
 * Provides: user, isAuthenticated, isLocked, isLoading,
 * pinAttemptsRemaining, login, logout, verifyPin, lock.
 */
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error(
      'useAuth deve essere usato all\'interno di <AuthProvider>',
    );
  }
  return ctx;
}
